import { useState } from "react";
import { setKey, api } from "@/lib/api";
import { Shield } from "lucide-react";
import { useBranding } from "@/hooks/useBranding";

export default function AccessGate({ onEnter }) {
  const brandName = useBranding();
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    const key = value.trim();
    if (!key) return;
    setBusy(true);
    setError("");
    try {
      await api.verifyKey(key);
      setKey(key);
      onEnter();
    } catch (err) {
      if (err?.response?.status === 401) {
        setError("Clave de acceso inválida. Verifica e intenta de nuevo.");
      } else {
        // Endpoint no disponible (404) o error de red: no se puede validar → permitir entrar
        setKey(key);
        onEnter();
      }
    } finally {
      setBusy(false);
    }
  };
  return (
    <div
      className="min-h-screen flex items-center justify-center p-6 relative"
      style={{
        backgroundImage:
          "linear-gradient(rgba(10,10,10,.82),rgba(10,10,10,.92)), url('https://images.unsplash.com/photo-1514539079130-25950c84af65?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <form
        onSubmit={submit}
        data-testid="access-gate-form"
        className="card-surface glow-gold w-full max-w-md p-8 md:p-10"
      >
        <div className="flex flex-col items-center text-center">
          <img src="/logo.png?v=20260724-groups" alt={brandName} className="w-28 h-28 rounded-lg mb-4 object-contain" />
          <span className="overline text-gold">Panel de Administración</span>
          <h1 className="text-3xl font-heading font-bold mt-1 mb-1" data-testid="access-gate-brand-name">{brandName}</h1>
          <p className="text-muted-foreground text-sm mb-8">
            Bot de Clash of Clans para WhatsApp
          </p>
        </div>
        <label className="overline block mb-2">Clave de acceso</label>
        <input
          data-testid="access-key-input"
          type="password"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Introduce tu clave"
          className="w-full bg-obsidian border border-white/10 rounded-md text-white px-4 py-3 mb-5 focus:border-gold focus:ring-1 focus:ring-gold outline-none font-mono"
        />
        <button
          data-testid="access-submit-button"
          type="submit"
          disabled={busy}
          className="w-full bg-gold text-black font-bold rounded-md py-3 hover:brightness-95 transition-all flex items-center justify-center gap-2 disabled:opacity-60"
        >
          <Shield size={18} /> {busy ? "Verificando…" : "Entrar al Panel"}
        </button>
        {error && (
          <p data-testid="access-error" className="text-crimson text-sm text-center mt-4">{error}</p>
        )}
        <p className="text-xs text-muted-foreground text-center mt-6">
          📲 Soporte: +17868740733
        </p>
      </form>
    </div>
  );
}
